import './Polyfills/Closest.js'
import './Polyfills/Remove.js'
import './Polyfills/CustomEvent.js'
import '../Components/Organism/Header/Header.js'
import '../Components/Organism/Hero/Hero.js'
import '../Components/Molecule/BrandPartnerBar/BrandPartnerBar.js'
import '../Components/Molecule/Breadcrumb/Breadcrumb.js'
import '../Components/Molecule/JWPlayer/JWPlayer.js'
import '../Components/Organism/Accordion/Accordion.js'
import '../Components/Molecule/CoverSlider/CoverSlider.js'
import '../Components/Molecule/ImageCard/ImageCard.js'
import '../Components/Organism/SliderSwiper/SliderSwiper.js'
import '../Components/Molecule/FactCounter/FactCounter.js'
import '../Components/Molecule/ImageZoom/ImageZoom.js'
import '../Components/Molecule/ImageGallery/ImageGallery.js'
import '../Components/Molecule/Map/Map.js'
// SP:
import sp from './SpLib.js'

// SP Popup Facebook
document.querySelectorAll('[data-eventlistener="js-popup-fb"]').forEach(function (linkTag) {
  linkTag.addEventListener('click', (event) => {
    event.preventDefault()
    const url = linkTag.getAttribute('href')
    sp.openPopup(url, 0, 0, 650, 425, 0, 0)
  })
})

// SP Popup Twitter
document.querySelectorAll('[data-eventlistener="js-popup-x"]').forEach(function (linkTag) {
  linkTag.addEventListener('click', (event) => {
    event.preventDefault()
    const url = linkTag.getAttribute('href')
    sp.openPopup(url, 0, 0, 550, 485, 0, 0)
  })
})

// SP Check Reduced Motion
sp.checkReducedMotion()
